import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Box, LinearProgress, Switch } from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import moment from 'moment';

import { stationListRequest } from '../actions/stationQueryAction';

import StationCell from './StationCell';
import { ACTIVE_TIME } from '../config';

const pageCells = 8;
const updatePeroid = 8000;
const updatePagePeroid = 45000;

var startTime = (new Date()).setHours(ACTIVE_TIME.start_hour, ACTIVE_TIME.start_minute);
var endTime = (new Date()).setHours(ACTIVE_TIME.end_hour, ACTIVE_TIME.end_minute);

var totals = 0;
var totalPages = 1;
var updateInterval = undefined;
var stationCellInfo = [];
var updateIndex = 0;

const StationList = () => {
    const stationList = useSelector(state => state.stationList);
    const dispatch = useDispatch();
    //const [pagingInfo, setPagingInfo] = useState({ page: 1, updating: 3 });
    const [page, setPage] = useState(Math.ceil((updateIndex + 1) / pageCells));
    const [autoUpdate, setAutoUpdate] = useState(false);
    const [showStation, setShowStation] = useState([]);
    const [refresh, setRefresh] = useState(moment.now());

    useEffect(() => {
        if (stationList.status === 0) {
            dispatch(stationListRequest());
        } else {
            if (stationList.status === 2) {
                if (stationList.stations && stationList.stations.length > 0) {
                    totals = stationList.stations.length;
                    totalPages = Math.ceil(stationList.stations.length / pageCells);
                    stationCellInfo = stationList.stations.map((s, i) => ({ index: i, info: s, record: { devices: [], inverters: [] } }));
                    setShowStation(stationCellInfo.slice(0, pageCells));

                    var to = setTimeout(() => {
                        setAutoUpdate(true);
                        setRefresh(moment.now());
                    }, 2000);
                }
            }
        }

        return () => {
            clearTimeout(to);
            clearTimeout(updateInterval);
        }
    }, [stationList, dispatch]);


    useEffect(() => {
        if (autoUpdate) {

            let timeout = updatePeroid;
            if (((updateIndex + 1) % pageCells === 0) || (updateIndex + 1) === totals)
                timeout = updatePagePeroid;


            if (updateIndex < totals) {
                let currPage = Math.ceil((updateIndex + 1) / pageCells);
                if (currPage !== page)
                    setPage(currPage);
            } else {
                updateIndex = 0;
                setPage(1);
                let current = new Date();
                if (current < startTime || current > endTime)
                    setAutoUpdate(false);
            }

            updateInterval = setTimeout(() => {
                updateIndex = updateIndex + 1;
                setRefresh(moment.now());

            }, timeout);

        }

        return () => {
            if (updateInterval)
                clearTimeout(updateInterval);
        }
    }, [refresh]);

    useEffect(() => {
        if (page > 0) {
            setShowStation(stationCellInfo.slice((page - 1) * pageCells, page * pageCells));
        }
    }, [page]);

    const autoUpdateChanged = (event) => {
        setAutoUpdate(event.target.checked);
        setRefresh(moment.now());
    };

    const pageChanged = (event, value) => {
        event.preventDefault();
        updateIndex =  (value - 1) * pageCells ;
        setRefresh(moment.now());
        setPage(value);
    };

    return (
        <Box p={2} pt={1}>
            {stationList.status === 1 ?
                (<>
                    <Box pb={1} textAlign="center" fontSize="h5.fontSize" color="green">資料載入中 ...</Box>
                    <LinearProgress />
                </>) : null}


            {stationList.error ? (
                <Box textAlign="center" fontSize="h5.fontSize" color="red">{stationList.error}, 請稍後再試 !!!</Box>
            ) : null}

            {stationList.status === 2 && totals > 0 ?
                <Box display="flex">
                    <Box flexGrow={1}><Pagination size="small" color="primary" count={totalPages} page={page} onChange={pageChanged} /></Box>
                    <Box textAlign="right"><Switch color="primary" checked={autoUpdate} onChange={(e) => autoUpdateChanged(e)} />輪詢</Box>
                </Box> : null}

            <Grid container spacing={1}>

                {stationList.status === 2 ?
                    showStation.map((item, index) => {
                        return(
                        <Grid key={index} item xs={12} md={6} lg={3}>
                            <StationCell station={item.info} updating={autoUpdate && item.index === updateIndex} />
                        </Grid>
                    )}) : null}
            </Grid>
        </Box>
    );
}

export default StationList;